import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../services/Auth/auth.service';
import { Booking, BookingService } from '../../../services/Booking/booking.service';
import moment from 'moment';
import { PageService } from '../../../services/Page/page.service';
import { MomentFormatPipe } from "../../../moment.pipe";
import { DashBookingCardComponent } from "../dash-booking-card/dash-booking-card.component";
import { CsvDownloadComponent } from "../../UI/csv-download/csv-download.component";

@Component({
    selector: 'app-dashboard-booking-requests',
    imports: [
    CommonModule,
    RouterModule,
    MomentFormatPipe,
    DashBookingCardComponent,
    CsvDownloadComponent
],
    templateUrl: './dashboard-booking-requests.component.html',
    styleUrl: './dashboard-booking-requests.component.scss'
})
export class DashboardBookingRequestsComponent {
    
    public hashmap: Map<string, Booking[]> = new Map();
    public isLoaded: boolean = false

    public csvList: any[] = []

    constructor(
        public authService: AuthService,
        public bookingService: BookingService,
        public pageService: PageService
    ) {
        this.bookingService.getPendingAll().subscribe(res => {
            this.csvList = []
            this.isLoaded = false
            this.hashmap.clear()
            let now = new Date()

            // res = res.filter((booking) => booking.endDate.toDate() > now  );

            let ids : number[] = res.map(item => item.Dx)

            this.pageService.getMoviesByIds(ids).then(movies => {
                movies.forEach(movie => {
                    res.forEach(booking => {
                        if(booking.Dx == movie.Dx) {
                            booking.movie = movie
                        }
                    })
                })
                
                res.sort((a, b) => b.created.toMillis() - a.created.toMillis())
    
                res.forEach(request => {
                    var itemDate = moment(request.created.toDate()).format('dddd, MMMM D, YYYY')
                    
                    var list = this.hashmap.get(itemDate)
                    if(list == undefined || list == null) {
                        list = []
                    }
                    list.push(request)
                    this.csvList.push(new Booking(request).getCsv())
                    this.hashmap.set(itemDate, list)
                })

                setTimeout(() => {
                    this.isLoaded = true
                }, 500);
            })


            
        })
    }

    openBookingDash(booking: Booking) {
        this.bookingService.dashOpen(booking)
    }
}
